const defaultOptions = {
    stepIsValid: async (_step) => true,
    frames: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ]
};
export default defaultOptions;
